import React from "react";
import { FooterStyles } from "./Footer.styled";
import FooterModal from "./FooterModal";

const Footer = () => {
  var year = new Date().getFullYear();
  const FooterContent = [
    {
      label: "Privacy Policy",
      url: "https://www.claytonhomes.com/privacy?source=ConsumerAffairs",
    },
    {
      label: "Legal",
      url: "https://www.claytonhomes.com/legal?source=ConsumerAffairs",
    },
  ];

  let footerContentNodes = FooterContent
    ? FooterContent.map((footerLink, i) => {
        return (
          <FooterModal label={footerLink.label} url={footerLink.url} key={i} />
        );
      })
    : null;

  return (
    <FooterStyles>
      <footer>
        <div>&copy; 1998-{year} Clayton.</div>
        {footerContentNodes}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
          }}
        >
          Do Not Sell or Share My Personal Information
        </a>
      </footer>
    </FooterStyles>
  );
};

export default Footer;
